module.exports = __webpack_public_path__ + "img/loan-status7.5315a62a.png";